import { format } from 'date-fns';
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Image, Navbar, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { BiLeftArrowAlt } from "react-icons/bi";
import { HiArrowLeft } from 'react-icons/hi';
import Loader from "react-js-loader";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { useNavigate, useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import stempelIcon from '../../icons/stempel.png';
import ttdIcon from '../../icons/ttd.png';
import Header from "../../Layout/Header";
import SidebarMenu from "../../Layout/SidebarMenu";
import BrandLogo from '../../logo.png';
import { useAppConfig } from '../../Utils/AppConfigContext';
import { getEndpointUrl, numberToRomawi, terbilang } from "../../Utils/Common";
import Error404 from '../Error404';

const CetakPurchasepurchase = ({ item }) => {
    const componentRef = useRef();

    const { config, loading, error, getSignatureName, getSignatureRole, getLogoUrl, getSignatureStampUrl, getSignatureUrl } = useAppConfig();

    const [error404, setError404] = useState(false);

    const [isLoading, setLoading] = useState(true);

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const navigate = useNavigate();

    const params = useParams();

    const [purchase, setPurchase] = useState([]);

    const fetchDatapurchase = useCallback(async (purchase_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/purchase/${purchase_id !== undefined ? purchase_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setPurchase(json.results);
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchDatapurchase(params.purchase_id);
    }, [params]);


    return error404 ? <Error404 /> : (
        <>
            <div className="d-block d-sm-none d-print-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Cetak Pembayaran</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
            </div>
            <div className="d-none d-sm-inline d-print-none">
                <Header />
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <Container className="mt-4">
                <Row className="mb-4 d-print-none d-print-none">
                    <Col lg={8} md={9} sm={12} className="offset-md-2">
                        <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3 d-none d-sm-inline"><BiLeftArrowAlt /> Kembali</Button>
                        <ReactToPrint
                            trigger={() => <Button variant="outline-secondary" className="mx-2">Cetak Bukti Pembayaran</Button>}
                            content={() => componentRef.current}
                        />
                        {/* <Button variant="success">Kirim Bukti Pembayaran</Button> */}
                    </Col>
                </Row>
                {isLoading ?
                    <Row>
                        <Col className="d-flex justify-content-center mt-5 pt-5 mb-3">
                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                        </Col>
                    </Row> :
                    <Row>
                        <Helmet>
                            <title>RECEIPT-{purchase.invoice.customerName}</title>
                        </Helmet>
                        <Col lg={8} md={9} sm={12} className="offset-md-2 mt-5" ref={componentRef}>
                            <Row>
                                <Col>
                                    <Image src={getLogoUrl() || BrandLogo} alt="Brand Logo" fluid className="mb-3" />
                                </Col>
                            </Row>
                            <Row className="fs-14 mt-3">
                                <Col className="text-center">
                                    <strong className="text-uppercase fw-bold">BUKTI PEMBAYARAN</strong>
                                </Col>
                            </Row>
                            <Row className="fs-13 mt-3">
                                <Col className="d-flex justify-content-end">
                                    <table className="fs-13">
                                        <tr>
                                            <td width={140}>No Tagihan</td>
                                            <td width={20}>:</td>
                                            <td>{`PINV/${numberToRomawi(format(new Date(purchase.purchaseDate), 'MM'))}/${format(new Date(purchase.purchaseDate), 'yy')}/${purchase.id}`}</td>
                                        </tr>
                                        <tr>
                                            <td>Tanggal</td>
                                            <td>:</td>
                                            <td><Moment format="DD/MM/YYYY">{purchase.purchaseDate}</Moment></td>
                                        </tr>
                                    </table>
                                </Col>
                            </Row>
                            <Row className="mt-3 fs-13">
                                <Col>
                                    <table className="table table-bordered fs-13 mt-3">
                                        <tr>
                                            <td width={150}>Sudah terima dari</td>
                                            <td className="text-center" width={50}>:</td>
                                            <td className="text-uppercase fw-bold">{purchase.invoice.customerName}</td>
                                        </tr>
                                        <tr className="align-top">
                                            <td>Jumlah yang diterima</td>
                                            <td className="text-center" width={50}>:</td>
                                            <td>
                                                <NumericFormat
                                                    value={purchase.amountPaid}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    className="bg-transparent p-0"
                                                    prefix={'Rp'}
                                                    renderText={(value, props) => <span {...props}>{value},-</span>} /><br />
                                                <span className="fst-italic bg-transparent p-0 text-capitalize">{`"${terbilang(purchase.amountPaid)} Rupiah"`}</span>
                                            </td>
                                        </tr>
                                        <tr className="align-top">
                                            <td>Untuk Pembayaran</td>
                                            <td className="text-center" width={50}>:</td>
                                            <td>{purchase.paymentDescription}</td>
                                        </tr>
                                    </table>
                                </Col>
                            </Row>
                            <Row className="mt-5 fs-13">
                                <Col>
                                    <p className="px-5 mb-0 pb-0">Hormat Kami,</p>
                                    <div className="stempel">
                                        <Image src={getSignatureStampUrl() || stempelIcon} alt="Stempel Image" className="mx-3" width={250} />
                                    </div>
                                    <Image src={getSignatureUrl() || ttdIcon} alt="TTD Image" className="mx-3 ttd" width={150} />
                                    <p className="px-4">
                                        <span className="text-uppercase fw-medium text-decoration-underline">{getSignatureName() || "KRISMA PRIANJANI"}</span><br />
                                        <span>{getSignatureRole() || "DIREKTUR"}</span>
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                }
            </Container>
        </>
    );
}

export default CetakPurchasepurchase;
